export default "__VITE_ASSET__DTX$kH2Q__"